/* eslint-disable require-jsdoc */
/* eslint-disable no-magic-numbers */
import { DATE_FORMAT_MIN_WITH_YEAR } from 'config/app';
import moment from 'moment-timezone';

export function momentNZ(date) {
    return moment(date).tz('Pacific/Auckland');
}

/**
 * Check if an event/exhibition is past by comparing end date with current date
 * Uses UTC for consistent comparison across timezones
 * @param {number} endDate - End date timestamp
 * @returns {boolean} True if the event has ended
 */
export function isEventPast(endDate) {
    if (!endDate) {
        return false;
    }

    // Use UTC for date comparison to ensure consistency regardless of server timezone
    // Compare dates at day level (start of day) for accurate "past" determination
    const now = moment.utc().startOf('day');
    const endDay = moment.utc(endDate).startOf('day');

    return endDay.isBefore(now);
}

export function formatDateRange(start, end, format = DATE_FORMAT_MIN_WITH_YEAR) {
    if (!start) {
        return '';
    }

    const startMoment = momentNZ(start).startOf('day');
    const endMoment = end ? momentNZ(end).startOf('day') : null;

    const startFormatted = startMoment.format(format);

    // Check if end date is valid and different from start date
    if (endMoment && endMoment.isValid() && endMoment.year() !== 1970 && !endMoment.isSame(startMoment)) {
        const endFormatted = endMoment.format(format);

        return `${startFormatted} - ${endFormatted}`;
    }

    return startFormatted;
}
